import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as buttons from '@xingternal/malt-button';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './ButtonGroup.css';

const TestableDiv = testable(QA_MALT, 'div');

const buttonTypes = Object.keys(buttons).map(key => buttons[key]);

const isButton = childComponent =>
  childComponent !== null && buttonTypes.includes(childComponent.type);

const renderChildren = ({
  children: childComponents,
  responsiveFullWidth,
  responsiveStretch,
}) => {
  return Children.map(childComponents, childComponent => {
    if (!isButton(childComponent)) {
      return childComponent;
    } else {
      return {
        ...childComponent,
        props: {
          ...childComponent.props,
          className: classNames(
            styles.buttonSpacing,
            { [styles.responsiveFullWidthButton]: responsiveFullWidth },
            { [styles.responsiveStretchButton]: responsiveStretch },
            childComponent.props.className
          ),
        },
      };
    }
  });
};

const ButtonGroup = ({
  children,
  className,
  responsiveFullWidth,
  responsiveStretch,
  testId,
}) => (
  <TestableDiv
    className={classNames(styles.buttonGroup, className, {
      [styles.responsiveButtonGroup]: responsiveFullWidth || responsiveStretch,
      [styles.responsiveFullWidthButtonGroup]: responsiveFullWidth,
      [styles.responsiveStretchButtonGroup]: responsiveStretch,
    })}
    testId={testId}
  >
    {renderChildren({ children, responsiveFullWidth, responsiveStretch })}
  </TestableDiv>
);

ButtonGroup.propTypes = {
  /** Child elements of the button group */
  children: PropTypes.node,
  /** Add a custom classname to the button group if you need one. */
  className: PropTypes.string,
  /** makes each button take the full width on handhelds */
  responsiveFullWidth: PropTypes.bool,
  /** stretch the buttons to fill the full width on one line on handhelds */
  responsiveStretch: PropTypes.bool,
  /** define a testid for the button group */
  testId: PropTypes.string,
};

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
